invHdApp.
factory('StockMovement', ['$http', function($http) {
    return {
      all: function(data) {
        return $http.post('api/stock-movements',data);
      },
      get: function(id) {
        return $http.get('api/stock-movement/' + id);
      },
      new: function(id) {
        return $http.get('api/new-stock-movement');
      },
      delete: function(id) {
        return $http.delete('api/delete-stock-movement/' + id);
      },
      save: function(data) {
        return $http.post('api/save-stock-movement',data);
      },
      update: function(data) {
        return $http.post('api/update-stock-movement',data);
      }
    };
}]);